export default "__VITE_ASSET__BHApd3Fx__"